<ng-container *ngIf="mobileDisplay">
    <ng-container *ngTemplateOutlet="discussionList"></ng-container>

    <module-content>
        <button (click)="onNewDiscussionClicked()" mat-raised-button color="accent" class="mobile-new-discussion">
            {{ 'ChatNewDiscussion'|translate }}
        </button>
    </module-content>
</ng-container>

<ng-container *ngIf="!mobileDisplay">
    <div class="container">
        <button mat-mini-fab class="fab" color="default"
            (menuOpened)="populateDiscussions()"
            [matTooltip]="'Chat' | translate"
            [matMenuTriggerFor]="menu"
        >
            <!--<mat-icon *ngIf="totalUnseenMessages > 0" color="primary" matBadge="{{ totalUnseenMessages }}" matBadgePosition="before" matBadgeColor="accent">chat_bubble_outline</mat-icon>
            <mat-icon *ngIf="totalUnseenMessages <= 0" color="primary">chat_bubble_outline</mat-icon>
-->
            <mat-icon color="primary">chat_bubble_outline</mat-icon>
            <div class="counter background-color-warn" *ngIf="(chatCounterService.totalUnseen$ | async) as total">
                {{ total }}
            </div>
        </button>
    </div>

    <mat-menu #menu="matMenu" xPosition="before">
        <div class="main-title">{{ 'ChatDiscussions' | translate }}</div>

        <ng-container *ngTemplateOutlet="discussionList"></ng-container>

<!--<ng-container *ngIf="(discussions$ | async) as discussions; else loadingDiscussion">
            <ng-container *ngIf="discussions.length > 0; else emptyDiscussion">
                <mat-nav-list class="chat-discussion-list">
                    <mat-list-item *ngFor="let discussion of discussions" class="discussion-item" layout="row" (click)="openDiscussion(discussion)">
                        <img matListAvatar *ngIf="!discussion.isGroup && null !== discussion.recipient.user.avatarUrl" src="{{ conf.storageRootUrl + discussion.recipient.user.avatarUrl}}" alt="avatar" class="avatar rounded-circle mr-2 ml-0">
                        <i matListIcon class="material-icons" *ngIf="discussion.isGroup || null === discussion.recipient.user.avatarUrl">
                            supervised_user_circle
                        </i>

                        <div mat-line fxLayout="row" fxLayoutAlign="space-between center" >
                            <div class="title">
                                {{ discussion.displayName }}
                            </div>
                            <div class="date" *ngIf="discussion.latestMessage">
                                {{ discussion.latestMessage.date | dateClosest:'closest-short' }}
                            </div>
                        </div>

                        <div mat-line class="message" *ngIf="discussion.latestMessage">
                            {{ discussion.latestMessage.text | emojify | shorten:20:'...' }}
                        </div>

                        <div class="badge" *ngIf="discussion.unseenMessages > 0">{{ discussion.unseenMessages }}</div>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                </mat-nav-list>
            </ng-container>
        </ng-container>-->

        <mat-divider></mat-divider>

        <button (click)="onNewDiscussionClicked()" mat-menu-item>
            <mat-icon>group_add</mat-icon>
            <span>{{ 'ChatNewDiscussion'|translate }}</span>
        </button>
    </mat-menu>
</ng-container>

<ng-template #loadingDiscussion>
    <mat-spinner diameter="36"></mat-spinner>
</ng-template>

<ng-template #emptyDiscussion>
    <div class="empty-discussion-list">
        {{ 'ChatEmptyDiscussion' |translate }}
    </div>
</ng-template>

<!--
<ng-template #discussionRef></ng-template>
-->

<ng-template #discussionList>
    <ng-container *ngIf="(discussions$ | async) as discussions; else loadingDiscussion">
        <ng-container *ngIf="discussions.length > 0; else emptyDiscussion">
            <mat-nav-list class="chat-discussion-list">
                <mat-list-item *ngFor="let discussion of discussions" class="discussion-item" (click)="openDiscussion(discussion)">
                  <div class="discussion-item-row">
                    <div class="discussion-icon">
                      <img matListAvatar *ngIf="!discussion.isGroup && null !== discussion.recipient?.user?.avatarUrl"
                           ngSrc="{{ conf.storageRootUrl + discussion.recipient?.user?.avatarUrl}}" width="32" height="32" alt="avatar" class="avatar rounded-circle mr-2 ml-0">
                      <i matListIcon class="material-icons" *ngIf="discussion.isGroup || null === discussion.recipient?.user?.avatarUrl">
                          supervised_user_circle
                      </i>
                    </div>
                    <div class="discussion-text">
                      <div mat-line class="discussion-line-1">
                          <div class="title">
                              {{ discussion.displayName }}
                          </div>
                          <div class="date" *ngIf="discussion.latestMessage">
                              {{ discussion.latestMessage.date ?? '' | dateClosest:'closest-short' }}
                          </div>
                      </div>

                      <div mat-line class="message" *ngIf="discussion.latestMessage">
                          {{ discussion.latestMessage.text ?? '' | emojify | shorten:20:'...' }}
                      </div>
                    </div>
                  </div>
                  <div class="badge" *ngIf="discussion.unseenMessages > -10">{{ discussion.unseenMessages }}</div>
                </mat-list-item>
                <mat-divider></mat-divider>
            </mat-nav-list>
        </ng-container>
    </ng-container>
</ng-template>
